
 
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const AcceptOrDeclineCollaboration = /* GraphQL */ `mutation AcceptOrDeclineCollaboration(
  $collaborationRequest: collaborationUpdateInput!
) {
  AcceptOrDeclineCollaboration(collaborationRequest: $collaborationRequest) {
    data {
      collaborationId
      createdAt
      createdBy
      description
      lastModifiedAt
      lastModifiedBy
      name
      objective
      orgType
      ownerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerEmail
      partnerInviteMessage
      partnerOrgType
      status
      __typename
    }
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AcceptOrDeclineCollaborationMutationVariables,
  APITypes.AcceptOrDeclineCollaborationMutation
>;
export const ApproveExportAudience = /* GraphQL */ `mutation ApproveExportAudience(
  $updateAudienceExportRequest: ApproveExportAudienceInput!
) {
  ApproveExportAudience(
    updateAudienceExportRequest: $updateAudienceExportRequest
  ) {
    approvalStatus
    approvedBy
    attributesMapping
    audienceFrom
    channelId
    engagement
    expireAt
    exportId
    exportStatus
    exportedAt
    exportedBy
    fileType
    folderPath
    orgType
    queryId
    queryName
    rejectReason
    targetChannel
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ApproveExportAudienceMutationVariables,
  APITypes.ApproveExportAudienceMutation
>;
export const ApproveQueryRecord = /* GraphQL */ `mutation ApproveQueryRecord($updateQueryRequest: ApproveQueryInput!) {
  ApproveQueryRecord(updateQueryRequest: $updateQueryRequest) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ApproveQueryRecordMutationVariables,
  APITypes.ApproveQueryRecordMutation
>;
export const CheckQueryStatus = /* GraphQL */ `mutation CheckQueryStatus {
  CheckQueryStatus {
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CheckQueryStatusMutationVariables,
  APITypes.CheckQueryStatusMutation
>;
export const CleanupSyntheticData = /* GraphQL */ `mutation CleanupSyntheticData(
  $syntheticDataInput: SyntheticDataGenerationInput!
) {
  CleanupSyntheticData(syntheticDataInput: $syntheticDataInput) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CleanupSyntheticDataMutationVariables,
  APITypes.CleanupSyntheticDataMutation
>;
export const CleanupSyntheticResult = /* GraphQL */ `mutation CleanupSyntheticResult(
  $syntheticDataInput: SyntheticResultGenerationInput!
) {
  CleanupSyntheticResult(syntheticDataInput: $syntheticDataInput) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CleanupSyntheticResultMutationVariables,
  APITypes.CleanupSyntheticResultMutation
>;
export const CreateActivationChannel = /* GraphQL */ `mutation CreateActivationChannel(
  $activationChannelInput: ActivationChannelInput!
) {
  CreateActivationChannel(activationChannelInput: $activationChannelInput) {
    awsRegion
    bucketName
    channelId
    channelType
    connectionStatus
    createdAt
    createdBy
    description
    engagement
    iamRoleArn
    lastModifiedAt
    lastModifiedBy
    name
    orgType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateActivationChannelMutationVariables,
  APITypes.CreateActivationChannelMutation
>;
export const CreateCharts = /* GraphQL */ `mutation CreateCharts($input: SaveChartInput!) {
  CreateCharts(input: $input) {
    athenaExecutionId
    chartId
    chartType
    chartsImageUrl
    config
    createdAt
    createdBy
    dashboardIds
    description
    engagement
    lastModifiedAt
    lastModifiedBy
    name
    orgType
    queryId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChartsMutationVariables,
  APITypes.CreateChartsMutation
>;
export const CreateCollaboration = /* GraphQL */ `mutation CreateCollaboration($collaborationRequest: collaborationCreateInput!) {
  CreateCollaboration(collaborationRequest: $collaborationRequest) {
    data {
      collaborationId
      createdAt
      createdBy
      description
      lastModifiedAt
      lastModifiedBy
      name
      objective
      orgType
      ownerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerEmail
      partnerInviteMessage
      partnerOrgType
      status
      __typename
    }
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCollaborationMutationVariables,
  APITypes.CreateCollaborationMutation
>;
export const CreateDashboard = /* GraphQL */ `mutation CreateDashboard($input: SaveDashboardInput!) {
  CreateDashboard(input: $input) {
    chartIds
    createdAt
    createdBy
    dashboardId
    dashboardImageUrl
    description
    engagement
    lastModifiedAt
    lastModifiedBy
    layout
    name
    orgType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDashboardMutationVariables,
  APITypes.CreateDashboardMutation
>;
export const CreateEngagement = /* GraphQL */ `mutation CreateEngagement($createEngagementInput: CreateEngagementInput!) {
  CreateEngagement(createEngagementInput: $createEngagementInput) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEngagementMutationVariables,
  APITypes.CreateEngagementMutation
>;
export const CreateModel = /* GraphQL */ `mutation CreateModel($input: CreateModelInput!) {
  CreateModel(input: $input) {
    data {
      athenaExecutionId
      createdAt
      createdBy
      engagement
      images
      lastModifiedAt
      lastModifiedBy
      lookalikeNumber
      maxLookalikeNumber
      metadata
      modelId
      modelType
      name
      orgType
      parentId
      queryId
      queryName
      seedAudienceSize
      status
      __typename
    }
    statusCode
    statusMessage
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateModelMutationVariables,
  APITypes.CreateModelMutation
>;
export const CreateNewEngagement = /* GraphQL */ `mutation CreateNewEngagement(
  $createEngagementInput: CreateNewEngagementInput!
) {
  CreateNewEngagement(createEngagementInput: $createEngagementInput) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNewEngagementMutationVariables,
  APITypes.CreateNewEngagementMutation
>;
export const CreateOrganization = /* GraphQL */ `mutation CreateOrganization($organizationInput: OrganizationInput!) {
  CreateOrganization(organizationInput: $organizationInput) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrganizationMutationVariables,
  APITypes.CreateOrganizationMutation
>;
export const CreateQueryRecord = /* GraphQL */ `mutation CreateQueryRecord($queryRecordInput: QueryRecordInput!) {
  CreateQueryRecord(queryRecordInput: $queryRecordInput) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQueryRecordMutationVariables,
  APITypes.CreateQueryRecordMutation
>;
export const CreateUser = /* GraphQL */ `mutation CreateUser($userRequest: UserInput!) {
  CreateUser(userRequest: $userRequest) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const DataConnectionActions = /* GraphQL */ `mutation DataConnectionActions(
  $dataConnectionActionsInput: DataConnectionActionsInput!
) {
  DataConnectionActions(
    dataConnectionActionsInput: $dataConnectionActionsInput
  ) {
    body
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DataConnectionActionsMutationVariables,
  APITypes.DataConnectionActionsMutation
>;
export const DeleteActivationChannel = /* GraphQL */ `mutation DeleteActivationChannel(
  $activationChannelInput: DeleteActivationChannelInput!
) {
  DeleteActivationChannel(activationChannelInput: $activationChannelInput) {
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteActivationChannelMutationVariables,
  APITypes.DeleteActivationChannelMutation
>;
export const DeleteChartsOrDashboards = /* GraphQL */ `mutation DeleteChartsOrDashboards($input: DeleteChartOrDashboardInput!) {
  DeleteChartsOrDashboards(input: $input) {
    message
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChartsOrDashboardsMutationVariables,
  APITypes.DeleteChartsOrDashboardsMutation
>;
export const DeleteCollaboration = /* GraphQL */ `mutation DeleteCollaboration($collaborationRequest: collaborationDeleteInput!) {
  DeleteCollaboration(collaborationRequest: $collaborationRequest) {
    data {
      collaborationId
      createdAt
      createdBy
      description
      lastModifiedAt
      lastModifiedBy
      name
      objective
      orgType
      ownerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerEmail
      partnerInviteMessage
      partnerOrgType
      status
      __typename
    }
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCollaborationMutationVariables,
  APITypes.DeleteCollaborationMutation
>;
export const DeleteModel = /* GraphQL */ `mutation DeleteModel($input: DeleteModelInput!) {
  DeleteModel(input: $input) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteModelMutationVariables,
  APITypes.DeleteModelMutation
>;
export const DeleteOrganizationBucket = /* GraphQL */ `mutation DeleteOrganizationBucket($deleteBucketInput: DeleteBucketInput!) {
  DeleteOrganizationBucket(deleteBucketInput: $deleteBucketInput) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrganizationBucketMutationVariables,
  APITypes.DeleteOrganizationBucketMutation
>;
export const EditDashboard = /* GraphQL */ `mutation EditDashboard($input: SaveDashboardInput!) {
  EditDashboard(input: $input) {
    chartIds
    createdAt
    createdBy
    dashboardId
    dashboardImageUrl
    description
    engagement
    lastModifiedAt
    lastModifiedBy
    layout
    name
    orgType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.EditDashboardMutationVariables,
  APITypes.EditDashboardMutation
>;
export const ExportAudience = /* GraphQL */ `mutation ExportAudience($exportAudienceRequest: ExportAudienceInput!) {
  ExportAudience(exportAudienceRequest: $exportAudienceRequest) {
    approvalStatus
    approvedBy
    attributesMapping
    audienceFrom
    channelId
    engagement
    expireAt
    exportId
    exportStatus
    exportedAt
    exportedBy
    fileType
    folderPath
    orgType
    queryId
    queryName
    rejectReason
    targetChannel
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ExportAudienceMutationVariables,
  APITypes.ExportAudienceMutation
>;
export const GenerateAiQuery = /* GraphQL */ `mutation GenerateAiQuery($generateAiQueryInput: GenerateAiQueryInput!) {
  GenerateAiQuery(generateAiQueryInput: $generateAiQueryInput) {
    body
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GenerateAiQueryMutationVariables,
  APITypes.GenerateAiQueryMutation
>;
export const GenerateSyntheticData = /* GraphQL */ `mutation GenerateSyntheticData(
  $syntheticDataInput: SyntheticDataGenerationInput!
) {
  GenerateSyntheticData(syntheticDataInput: $syntheticDataInput) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GenerateSyntheticDataMutationVariables,
  APITypes.GenerateSyntheticDataMutation
>;
export const GenerateSyntheticResult = /* GraphQL */ `mutation GenerateSyntheticResult(
  $syntheticDataInput: SyntheticResultGenerationInput!
) {
  GenerateSyntheticResult(syntheticDataInput: $syntheticDataInput) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GenerateSyntheticResultMutationVariables,
  APITypes.GenerateSyntheticResultMutation
>;
export const ListUsers = /* GraphQL */ `mutation ListUsers($userRequest: ListUserInput!) {
  ListUsers(userRequest: $userRequest) {
    Users {
      Attributes {
        Name
        Value
        __typename
      }
      Enabled
      Groups
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ListUsersMutationVariables,
  APITypes.ListUsersMutation
>;
export const NotifyDataConnectionCreation = /* GraphQL */ `mutation NotifyDataConnectionCreation(
  $connectionCreationResponse: ConnectionCreationResponse!
) {
  NotifyDataConnectionCreation(
    connectionCreationResponse: $connectionCreationResponse
  ) {
    body {
      connectionId
      message
      __typename
    }
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyDataConnectionCreationMutationVariables,
  APITypes.NotifyDataConnectionCreationMutation
>;
export const NotifyDataConnectionTest = /* GraphQL */ `mutation NotifyDataConnectionTest(
  $connectionTestResponse: ConnectionTestResponse!
) {
  NotifyDataConnectionTest(connectionTestResponse: $connectionTestResponse) {
    connectionId
    message
    status
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyDataConnectionTestMutationVariables,
  APITypes.NotifyDataConnectionTestMutation
>;
export const NotifyJobComplete = /* GraphQL */ `mutation NotifyJobComplete(
  $AIQuerryGeneratedResponse: AIQuerryGeneratedResponse!
) {
  NotifyJobComplete(AIQuerryGeneratedResponse: $AIQuerryGeneratedResponse) {
    body {
      aiComments
      generatedSql
      jobId
      status
      updatedAt
      __typename
    }
    jobId
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyJobCompleteMutationVariables,
  APITypes.NotifyJobCompleteMutation
>;
export const ReminderEmailForExportAudience = /* GraphQL */ `mutation ReminderEmailForExportAudience {
  ReminderEmailForExportAudience {
    engagement
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReminderEmailForExportAudienceMutationVariables,
  APITypes.ReminderEmailForExportAudienceMutation
>;
export const ReminderEmailForQueryRecord = /* GraphQL */ `mutation ReminderEmailForQueryRecord {
  ReminderEmailForQueryRecord {
    engagement
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReminderEmailForQueryRecordMutationVariables,
  APITypes.ReminderEmailForQueryRecordMutation
>;
export const SendCollaborationInvite = /* GraphQL */ `mutation SendCollaborationInvite(
  $collaborationRequest: SendPartnerInviteRequest!
) {
  SendCollaborationInvite(collaborationRequest: $collaborationRequest) {
    data {
      collaborationId
      createdAt
      createdBy
      description
      lastModifiedAt
      lastModifiedBy
      name
      objective
      orgType
      ownerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerEmail
      partnerInviteMessage
      partnerOrgType
      status
      __typename
    }
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendCollaborationInviteMutationVariables,
  APITypes.SendCollaborationInviteMutation
>;
export const SubmitQueryRecord = /* GraphQL */ `mutation SubmitQueryRecord($updateQueryRequest: SubmitQueryInput!) {
  SubmitQueryRecord(updateQueryRequest: $updateQueryRequest) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitQueryRecordMutationVariables,
  APITypes.SubmitQueryRecordMutation
>;
export const TestAwsS3DataConnection = /* GraphQL */ `mutation TestAwsS3DataConnection(
  $testDataConnectionInput: AwsS3ConnectionInput!
) {
  TestAwsS3DataConnection(testDataConnectionInput: $testDataConnectionInput) {
    connectionId
    message
    status
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TestAwsS3DataConnectionMutationVariables,
  APITypes.TestAwsS3DataConnectionMutation
>;
export const TestDataConnection = /* GraphQL */ `mutation TestDataConnection($testDataConnectionInput: TestConnectionInput!) {
  TestDataConnection(testDataConnectionInput: $testDataConnectionInput) {
    connectionId
    message
    status
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TestDataConnectionMutationVariables,
  APITypes.TestDataConnectionMutation
>;
export const TestDatabricksDataConnection = /* GraphQL */ `mutation TestDatabricksDataConnection(
  $testDataConnectionInput: DatabricksTestConnectionInput!
) {
  TestDatabricksDataConnection(
    testDataConnectionInput: $testDataConnectionInput
  ) {
    connectionId
    message
    status
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TestDatabricksDataConnectionMutationVariables,
  APITypes.TestDatabricksDataConnectionMutation
>;
export const TestGoogleActivationChannel = /* GraphQL */ `mutation TestGoogleActivationChannel(
  $testRequest: TestGoogleActivationChannelInput
) {
  TestGoogleActivationChannel(testRequest: $testRequest) {
    customerInfo {
      currencyCode
      customerId
      descriptiveName
      timeZone
      __typename
    }
    message
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TestGoogleActivationChannelMutationVariables,
  APITypes.TestGoogleActivationChannelMutation
>;
export const TestRedshiftDataConnection = /* GraphQL */ `mutation TestRedshiftDataConnection(
  $testDataConnectionInput: RedshiftTestConnectionInput!
) {
  TestRedshiftDataConnection(
    testDataConnectionInput: $testDataConnectionInput
  ) {
    connectionId
    message
    status
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TestRedshiftDataConnectionMutationVariables,
  APITypes.TestRedshiftDataConnectionMutation
>;
export const TestS3ActivationChannel = /* GraphQL */ `mutation TestS3ActivationChannel($testRequest: TestS3ActivationChannelInput) {
  TestS3ActivationChannel(testRequest: $testRequest) {
    message
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TestS3ActivationChannelMutationVariables,
  APITypes.TestS3ActivationChannelMutation
>;
export const UpdateActivationChannel = /* GraphQL */ `mutation UpdateActivationChannel(
  $activationChannelInput: UpdateActivationChannelInput!
) {
  UpdateActivationChannel(activationChannelInput: $activationChannelInput) {
    awsRegion
    bucketName
    channelId
    channelType
    connectionStatus
    createdAt
    createdBy
    description
    engagement
    iamRoleArn
    lastModifiedAt
    lastModifiedBy
    name
    orgType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateActivationChannelMutationVariables,
  APITypes.UpdateActivationChannelMutation
>;
export const UpdateCollaboration = /* GraphQL */ `mutation UpdateCollaboration($collaborationRequest: collaborationUpdateInput!) {
  UpdateCollaboration(collaborationRequest: $collaborationRequest) {
    data {
      collaborationId
      createdAt
      createdBy
      description
      lastModifiedAt
      lastModifiedBy
      name
      objective
      orgType
      ownerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerEmail
      partnerInviteMessage
      partnerOrgType
      status
      __typename
    }
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCollaborationMutationVariables,
  APITypes.UpdateCollaborationMutation
>;
export const UpdateCollaborationDataset = /* GraphQL */ `mutation UpdateCollaborationDataset(
  $collaborationRequest: collaborationUpdateInput!
) {
  UpdateCollaborationDataset(collaborationRequest: $collaborationRequest) {
    data {
      collaborationId
      createdAt
      createdBy
      description
      lastModifiedAt
      lastModifiedBy
      name
      objective
      orgType
      ownerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerEmail
      partnerInviteMessage
      partnerOrgType
      status
      __typename
    }
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCollaborationDatasetMutationVariables,
  APITypes.UpdateCollaborationDatasetMutation
>;
export const UpdateExecutionQueryRecord = /* GraphQL */ `mutation UpdateExecutionQueryRecord($updateQueryRequest: ExecutionQueryInput!) {
  UpdateExecutionQueryRecord(updateQueryRequest: $updateQueryRequest) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExecutionQueryRecordMutationVariables,
  APITypes.UpdateExecutionQueryRecordMutation
>;
export const UpdateModel = /* GraphQL */ `mutation UpdateModel($input: UpdateModelInput) {
  UpdateModel(input: $input) {
    data {
      athenaExecutionId
      createdAt
      createdBy
      engagement
      images
      lastModifiedAt
      lastModifiedBy
      lookalikeNumber
      maxLookalikeNumber
      metadata
      modelId
      modelType
      name
      orgType
      parentId
      queryId
      queryName
      seedAudienceSize
      status
      __typename
    }
    statusCode
    statusMessage
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateModelMutationVariables,
  APITypes.UpdateModelMutation
>;
export const UpdateOrganizationDatabricksFlag = /* GraphQL */ `mutation UpdateOrganizationDatabricksFlag(
  $updateDatabricksFlagInput: UpdateDatabricksFlagInput!
) {
  UpdateOrganizationDatabricksFlag(
    updateDatabricksFlagInput: $updateDatabricksFlagInput
  ) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrganizationDatabricksFlagMutationVariables,
  APITypes.UpdateOrganizationDatabricksFlagMutation
>;
export const UpdateQueryRecord = /* GraphQL */ `mutation UpdateQueryRecord($updateQueryRequest: UpdateQueryInput!) {
  UpdateQueryRecord(updateQueryRequest: $updateQueryRequest) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQueryRecordMutationVariables,
  APITypes.UpdateQueryRecordMutation
>;
export const UpdateQueryRecordForInactiveCollaboration = /* GraphQL */ `mutation UpdateQueryRecordForInactiveCollaboration($engagement: String) {
  UpdateQueryRecordForInactiveCollaboration(engagement: $engagement) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQueryRecordForInactiveCollaborationMutationVariables,
  APITypes.UpdateQueryRecordForInactiveCollaborationMutation
>;
export const UpdateQueryRecordForInactiveEngagement = /* GraphQL */ `mutation UpdateQueryRecordForInactiveEngagement(
  $updateRequest: UpdateInactiveEngagementInput!
) {
  UpdateQueryRecordForInactiveEngagement(updateRequest: $updateRequest) {
    engagement
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQueryRecordForInactiveEngagementMutationVariables,
  APITypes.UpdateQueryRecordForInactiveEngagementMutation
>;
export const UpdateUser = /* GraphQL */ `mutation UpdateUser($userRequest: UpdateUserInput!) {
  UpdateUser(userRequest: $userRequest) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const UserActions = /* GraphQL */ `mutation UserActions($userRequest: UserActionsInput!) {
  UserActions(userRequest: $userRequest) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UserActionsMutationVariables,
  APITypes.UserActionsMutation
>;
export const createAdlsDataConnection = /* GraphQL */ `mutation CreateAdlsDataConnection($dataConnectionInput: AdlsConnectionInput!) {
  createAdlsDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAdlsDataConnectionMutationVariables,
  APITypes.CreateAdlsDataConnectionMutation
>;
export const createBigQueryDataConnection = /* GraphQL */ `mutation CreateBigQueryDataConnection(
  $dataConnectionInput: BigQueryConnectionInput!
) {
  createBigQueryDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBigQueryDataConnectionMutationVariables,
  APITypes.CreateBigQueryDataConnectionMutation
>;
export const createDatabricksDataConnection = /* GraphQL */ `mutation CreateDatabricksDataConnection(
  $dataConnectionInput: DatabricksConnectionInput!
) {
  createDatabricksDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDatabricksDataConnectionMutationVariables,
  APITypes.CreateDatabricksDataConnectionMutation
>;
export const createFederatedQueryDataConnection = /* GraphQL */ `mutation CreateFederatedQueryDataConnection(
  $dataConnectionInput: FederatedQueryConnectionInput!
) {
  createFederatedQueryDataConnection(
    dataConnectionInput: $dataConnectionInput
  ) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFederatedQueryDataConnectionMutationVariables,
  APITypes.CreateFederatedQueryDataConnectionMutation
>;
export const createGcsDataConnection = /* GraphQL */ `mutation CreateGcsDataConnection($dataConnectionInput: GcsConnectionInput!) {
  createGcsDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGcsDataConnectionMutationVariables,
  APITypes.CreateGcsDataConnectionMutation
>;
export const createRedshiftDataConnection = /* GraphQL */ `mutation CreateRedshiftDataConnection(
  $dataConnectionInput: RedshiftConnectionInput!
) {
  createRedshiftDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRedshiftDataConnectionMutationVariables,
  APITypes.CreateRedshiftDataConnectionMutation
>;
export const createS3DataConnection = /* GraphQL */ `mutation CreateS3DataConnection($dataConnectionInput: AwsS3ConnectionInput!) {
  createS3DataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateS3DataConnectionMutationVariables,
  APITypes.CreateS3DataConnectionMutation
>;
export const createSFTPDataConnection = /* GraphQL */ `mutation CreateSFTPDataConnection($dataConnectionInput: SFTPConnectionInput!) {
  createSFTPDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSFTPDataConnectionMutationVariables,
  APITypes.CreateSFTPDataConnectionMutation
>;
export const createSnowflakeDataConnection = /* GraphQL */ `mutation CreateSnowflakeDataConnection(
  $dataConnectionInput: SnowflakeConnectionInput!
) {
  createSnowflakeDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSnowflakeDataConnectionMutationVariables,
  APITypes.CreateSnowflakeDataConnectionMutation
>;
export const createSynapseDataConnection = /* GraphQL */ `mutation CreateSynapseDataConnection(
  $dataConnectionInput: SynapseConnectionInput!
) {
  createSynapseDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSynapseDataConnectionMutationVariables,
  APITypes.CreateSynapseDataConnectionMutation
>;
export const updateDataConnection = /* GraphQL */ `mutation UpdateDataConnection(
  $dataConnectionInput: UpdateDataConnectionInput!
) {
  updateDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDataConnectionMutationVariables,
  APITypes.UpdateDataConnectionMutation
>;
export const updateDataConnectionMetaData = /* GraphQL */ `mutation UpdateDataConnectionMetaData(
  $dataConnectionInput: UpdateDataConnectionMetaDataInput!
) {
  updateDataConnectionMetaData(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDataConnectionMetaDataMutationVariables,
  APITypes.UpdateDataConnectionMetaDataMutation
>;
export const updateSFTPDataConnection = /* GraphQL */ `mutation UpdateSFTPDataConnection($dataConnectionInput: SFTPConnectionInput!) {
  updateSFTPDataConnection(dataConnectionInput: $dataConnectionInput) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSFTPDataConnectionMutationVariables,
  APITypes.UpdateSFTPDataConnectionMutation
>;
